<template>
  <header class="navbar navbar-sticky navbar-expand-lg navbar-dark">
    <div class="container position-relative">
      <a class="navbar-brand" href="/">
        <img
          class="navbar-brand-regular"
          src="assets/img/logo_white.png"
          alt="brand-logo"
        />
        <img
          class="navbar-brand-sticky"
          src="assets/img/logo.png"
          alt="sticky brand-logo"
        />
      </a>
      <button
        class="navbar-toggler d-lg-none"
        type="button"
        data-toggle="navbarToggler"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="navbar-inner">
        <!--  Mobile Menu Toggler -->
        <button
          class="navbar-toggler d-lg-none"
          type="button"
          data-toggle="navbarToggler"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <nav>
          <ul class="navbar-nav" id="navbar-nav">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="javascript:;"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Features
              </a>
              <ul
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <li>
                  <a class="dropdown-item" href="/">SourceSync</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/pulse">Pulse</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-web">Web</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-player"
                    >Player</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-audience"
                    >Audience</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-ott">OTT</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/content-wallet"
                    >Wallet</a
                  >
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="javascript:;"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Technology
              </a>
              <ul
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <li>
                  <a class="dropdown-item" href="/">Smart Content</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-web">Smart Screens</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-player">NextGen TV</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-audience"
                    >Decentralization</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="/turnkey-ott"
                    >NFT Sponsorship</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="/content-wallet"
                    >NFT Minting</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" href="/content-wallet">Betting</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/content-wallet"
                    >Monetization</a
                  >
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Development<span
                      class="badge badge-pill badge-warning ml-2"
                      >New</span
                    ></a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        target="_blank"
                        href="https://admin.sourcesync.io"
                        >SDK</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/forgot">API</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/signup">Applications</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/forgot">Code Examples</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="javascript:;"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Enterprise
              </a>
              <ul
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Account<span class="badge badge-pill badge-warning ml-2"
                      >New</span
                    ></a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        target="_blank"
                        href="https://admin.sourcesync.io"
                        >Login</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/signup">Signup</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/forgot">Reset Password</a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Information</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item"
                        target="_blank"
                        href="https://help.sourcedigital.net"
                        >Help Center</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/newsletter">Newsletter</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/pricing">Pricing</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/faq">FAQ</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/faq">Press/Media kits</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/faq">For Investors</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="/faq">Staff Directory</a>
                    </li>
                    <li>
                      <a class="dropdown-item" target="_blank" href="https://portal.productboard.com/sourcedigital/1-sourcesync-roadmap/tabs/5-released"
                        >Product Roadmap</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Integrations</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/enterprise/white-labeling"
                        >White Labeling</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/cloud-spanning"
                        >Cloud Spanning</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/custom-domains"
                        >Custom Domains</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/vanity-links"
                        >Vanity links</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/on-prem"
                        >On-prem installation</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/analytics"
                        >Analytics</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/licensing"
                        >Licensing</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/source-code"
                        >Source Code</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Verticals</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/enterprise/white-labeling"
                        >Content Creators</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/cloud-spanning"
                        >Websites</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/custom-domains"
                        >Consumer Electronics</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/vanity-links"
                        >Entertainment Platforms</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/on-prem"
                        >Movie Studios</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/analytics"
                        >Education</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/licensing"
                        >Advertizing</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise-games"
                        >Game Studios</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/source-code"
                        >Sports Betting</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/enterprise/source-code"
                        >Politics</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="javascript:;"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Demos
              </a>
              <ul
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Smart Content</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/blog-two-column"
                        >People</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Places</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Products</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Events</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Kitchen Sink</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Build your own</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Smart Screens</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/blog-two-column"
                        >Syncronizing to content</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Device flow</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Live Chat</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Betting</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Build your own</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Content Wallet</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/blog-two-column"
                        >Trybal</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >ScreenKick</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Swager</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Build your own</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Turnkey Web</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/blog-two-column"
                        >Ideal site</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Problematic site</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Tons of videos</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Test your site</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Turnkey Player</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/blog-two-column"
                        >Basic Example</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Kitchen Sink</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >YouTube</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Vimeo</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Automatic Bandwidth</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Streaming</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Audio and other</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Turnkey Audience</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/blog-two-column"
                        >Content Listing</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-left-sidebar"
                        >Content Details Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Merchandise Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Star Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Events Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >News Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Blog Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Photos/Portfolio Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Custom Page</a
                      >
                    </li>
                  </ul>
                </li>
                <li class="dropdown-submenu">
                  <a class="dropdown-item dropdown-toggle" href="javascript:;"
                    >Turnkey OTT</a
                  >
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item" href="/blog-two-column"
                        >Category Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-three-column"
                        >Series Page</a
                      >
                    </li>
                    <li>
                      <a class="dropdown-item" href="/blog-details-left-sidebar"
                        >Content Details Page</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/supported-platforms">Platforms</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/supported-players">Players</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/supported-hardware">Hardware</a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="javascript:;"
                id="navbarDropdownMenuLink"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Contact
              </a>
              <ul
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <li>
                  <a class="dropdown-item" href="/contact-general">General Inquery</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/contact-sales">Sales</a>
                </li>
                <li>
                  <a class="dropdown-item" href="/contact-support">Support</a>
                </li>
              </ul>
            </li>

          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
</style>